import { ThunderDispatcher } from "@nu-art/thunderstorm-frontend/index";
export const dispatcher_OnFindingsContextUpdated = new ThunderDispatcher('__onFindingsContextUpdated');
//# sourceMappingURL=dispatcher.js.map